<template>
  <v-app>
    <v-main>
      <!-- <h1>{{ $t('hello') }}</h1>
      <div>
        <button @click="changeLanguage('en')">English</button>
        <button @click="changeLanguage('fr')">Français</button>
      </div> -->
      <router-view />
      <notifications group="foo" />
      <GlobalNotifications />
    </v-main>
  </v-app>
</template>

<script>
import GlobalNotifications from "@/components/GlobalNotifications.vue";
export default {
  name: "App",
  components: {
    GlobalNotifications,
  },
  data: () => ({
    //
  }),
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    }
  },
  created() {
    window.getApp = this;
  },
};
</script>
